module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Light.ae77d41dccf7e99e25cc79e38481abe3.woff2";